import { getRequest } from '../../../services/base'
import { useContext, useEffect, useState } from 'react'
import { NavContext } from '../../../context/global_context'
import Pagination from '../../common/Pagination'
import NoRecordsFound from '../../common/NoRecordsFound'
import { useParams } from 'react-router-dom'
import {
  SalesCodesContext,
  SET_SALES_CODE_DATA,
  SET_SELECTED_SALES_CODE_DATA,
} from './context/context'
import SalesCodesRow from './SalesCodesRow'
import CreateUpdateSalesCode from './form'

const SalesCodesAndGroup = (props) => {
  const { vehicle } = useParams()

  const [state, dispatch] = useContext(NavContext)
  const [salesCodeState, salesCodeDispatch] = useContext(SalesCodesContext)
  const [searchValue, setSearchValue] = useState('')
  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
    current_page: 1,
  })
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    getSalesCodeList(null)
  }, [])

  const getSalesCodeList = async (url = null) => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Fetching Sales Code Data',
        showLoader: true,
      },
      notification: {},
    })
    let response = await getRequest(
      url ? url : `/api/sales_codes/?vehicle=${vehicle}&search=${searchValue}`
    )
    salesCodeDispatch({ type: SET_SALES_CODE_DATA, data: response.results })
    setPagination(response.pagination)
    dispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  return (
    <>
      <CreateUpdateSalesCode
        showModal={showModal}
        setShowModal={setShowModal}
        getSalesCodeList={getSalesCodeList}
      />
      <form
        className="flex flex-col w-full space-y-2 pb-5"
        acceptCharset="UTF-8"
        onSubmit={(e) => {
          e.preventDefault()
          getSalesCodeList(null)
        }}
      >
        <div className="flex space-x-5">
          <div className="w-1/4">
            <input
              autoComplete="off"
              className="w-full bg-white h-10 px-5 pr-5 rounded focus:outline-none text-black"
              placeholder="Enter to search"
              type="search"
              name="search"
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value)
              }}
            />
          </div>
          <button className="bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded">
            Search
          </button>
        </div>
      </form>
      <div className="font-light">
        <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
          <div className="flex w-2/12 pl-10 items-center">Name</div>
          <div className="flex w-4/12 pl-6 items-center">Description</div>
          <div className="flex w-2/12 pl-6 items-center">Group </div>
          <div className=" w-4/12 pl-6">Group Description</div>
          <div className="w-2/12 pl-6">Default</div>
          <div className="w-2/12 pl-6"></div>
        </div>
      </div>
      {salesCodeState?.data?.map((sales_code, index) => {
        return (
          <SalesCodesRow
            {...sales_code}
            key={`sales-codes-${index}`}
            onEdit={() => {
              salesCodeDispatch({
                type: SET_SELECTED_SALES_CODE_DATA,
                data: { ...sales_code, index: index },
              })
              setShowModal(true)
            }}
          />
        )
      })}
      {salesCodeState?.data?.length < 1 && (
        <NoRecordsFound caption={"Sales code's not found"} loading={false} />
      )}
      <div className="py-6">
        <Pagination
          context={pagination}
          onClickNext={(e) => {
            getSalesCodeList(e)
          }}
          onClickPrev={(e) => {
            getSalesCodeList(e)
          }}
        />
      </div>
    </>
  )
}

export default SalesCodesAndGroup
